import React from 'react';
import Navbar from '../components/Navbar';
import ContactForm from '../components/ContactForm';

const Contact = () => {
  return (
    <div>
    <Navbar />
    <ContactForm />

    </div>
  );
}

export default Contact;
